import "./SectionHeader.scss";
import { useEffect, useRef } from "react";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";

function SectionHeader(props) {
  const el = useRef();
  const tl = useRef();

  useEffect(() => {
    // stuff
  }, []);

  const Logo = () => {
    return (
      <svg
        className={"logo-image"}
        xmlns="http://www.w3.org/2000/svg"
        width="60"
        height="21"
        viewBox="0 0 60 21"
        fill="none"
      >
        <path
          d="M0 21L5.32955 0H14.2223C18.3946 0 21.0441 2.64 21.0441 6.09C21.0441 9.33 18.76 12.03 15.2577 13.17L17.5418 21H11.4509L9.59319 13.74H7.58318L5.72546 21H0ZM8.71 9.3H12.06C13.8873 9.3 15.1968 7.95 15.1968 6.39C15.1968 5.25 14.405 4.5 13.3391 4.5H9.92819L8.71 9.3Z"
          fill="currentColor"
        />
        <path
          d="M23.2228 21L27.3342 4.8H21.7001L22.9182 0H39.9728L38.7546 4.8H33.1205L29.0092 21H23.2228Z"
          fill="currentColor"
        />
        <path
          d="M36.0323 21L41.3314 0H46.8741L51.4118 12.3L54.3659 0H60L54.7009 21H49.1582L44.59 8.7L41.6968 21H36.0323Z"
          fill="currentColor"
        />
      </svg>
    );
  };

  return (
    <div
      ref={el}
      className={`section-header section-${props.data.number} ${
        props.theme ? "theme-" + props.theme : ""
      }`}
    >
      <div className="box">
        <span className="act">{props.data.act}</span>
        <span className="numeral">{props.data.numeral}</span>
        <span className="title">{props.data.title}</span>
        <span className="logo">
          <Logo />
        </span>
      </div>
      <div className="box-mobile">
        <div className="row">
          <span className="act">{props.data.act}</span>
          <span className="numeral">{props.data.numeral}</span>
          <span className="logo">
            <Logo />
          </span>
        </div>
        <span className="title">{props.data.title}</span>
      </div>
    </div>
  );
}

export default SectionHeader;
